Vue.component('kk-instantsearch-item-skeleton', {
  template: "#kk-instantsearch-item-skeleton",
  data: () => ({}),
});
